import styled from "styled-components";

import BioImage from "../assets/images/Sofia-Ringstedt-2023.jpg"

export const IntroContainer = styled.div`
  display: grid;
  grid-template-rows: 1fr 1fr;
  grid-template-columns: 2fr 1fr;
  height: fit-content;
  background: #d8bdff;
  padding: 50px 35px 35px 35px;
  font-family: 'Spectral', 'times', serif;
  letter-spacing: -0.5;
  font-size: 1.3rem;
  line-height: 1.3;
  @media (max-width: 767px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export const Paragraph = styled.h4`
  grid-column: 1;
  grid-row: 1;
  width: fit-content;
  font-weight: 500;
`;

export const Mailtag = styled.a`
  grid-column: 1;
  grid-row: 2;
  width: fit-content;
  color: black;
  margin: 20px;
  cursor: pointer;
  font-weight: 400;
`;

export const IntroImage = styled.img`
  background-image: url(${BioImage});
  grid-column: 3;
  grid-row: 1/3;
  width: 280px;
  height: 380px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover; 
  @media (max-width: 767px) {
    width: 250px;
    height: 350px;
  }
`;